import React from "react";

const Circles = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 109 108" {...props}>
    <g transform="translate(-1605 -331.949)">
      <circle
        fill="#1089ff"
        opacity="0.35"
        cx="50.5"
        cy="50.5"
        r="50.5"
        transform="translate(1605 338.949)"
      />
      <circle
        fill="#001a70"
        opacity="0.37"
        cx="25.5"
        cy="25.5"
        r="25.5"
        transform="translate(1663 331.949)"
      />
    </g>
  </svg>
);

export default Circles;
